export default "__VITE_ASSET__B$8DV_5y__"